import juicytag from '../assets/juicytag.jpg'
import dronetracker from '../assets/dronetracker.jpg'
import magentafm from '../assets/magenta-fm.jpg'
import inspire from '../assets/inspire.jpg'
import lastdrummer from '../assets/lastdrummer.jpg'
import cjmobiledj from '../assets/cjmobiledj.jpg'
import chuckarnotes from '../assets/chuckarnotes.png'
import flexbox from '../assets/flexbox.jpg'
import bcw from '../assets/bcw.jpg'
import cheatsheets from '../assets/cheatsheets.jpg'
import ethos from '../assets/ethos.png'
import shadowban from '../assets/shadowban.jpg'
import cookiecutter from '../assets/cookiecutter.jpg'
import moderndj from '../assets/moderndj.jpg'

let count = -1;
function id(){
  count = count + 1;
  return count;
}
class Project {
  constructor({
    title,
    description,
    image,
    link,
    weight,
    stack
  }){
  Object.assign(this, {title, description, image, link, weight, stack})
  this.index = id();
  }
}

const pug = 'Pug', 
sass = 'Sass',
babel = 'Babel',
js = 'JavaScript',
es = 'ES2015',
webpack = 'Webpack',
vue = 'Vue.js',
vuex = 'Vuex',
firebase = 'Firebase',
rails = 'Ruby on Rails',
material = 'Material Design',
haml = 'HAML',
postgres = 'PostgreSQL',
gulp = 'Gulp',
browserify = 'Browserify',
unity = 'Unity',
unityCollab = 'Unity Collaborate (BETA)',
cSharp = 'C#',
heroku = 'heroku',
jQuery = 'jQuery',
reactNative = 'React Native',
react = 'React',
imageMagick = 'ImageMagick',
vanillajs = 'Vanilla JS',
html = 'HTML',
css = 'CSS',
node = 'Node.js',
ruby = 'Ruby',
git = 'Git',
github = 'Github',
angular = 'Angular 1.5.x',
flow = 'FlowType',
mocha = 'Mocha',
chai = 'Chai',
express = 'Express.js',
restAPI = 'REST API',
design = 'Design',
seo = 'SEO',

advancedJS = [
    js,
    babel,
    es,
    node,
],
toolkit = {
  advancedJS,
  vue:[
    vue,
    webpack,
    pug,
    sass,
    ...advancedJS,
    git,
  ],
  unity:[
    unity,
    unityCollab,
    cSharp,
    git,
  ],
  groundUp:[
    js,
    vanillajs,
    git,
  ],
}
const projects = [
  new Project({
    title:`CodeWorks Backpack`,
    description:`A classroom dashboard for CodeWorks students. (in beta)`,
    image:bcw,
    stack:[
      firebase,
      vuex,
      pug,
      ...toolkit.vue,
    ]
    
  }),
  new Project({
    title:`Boise CodeWorks Cheatsheets`,
    description:`A resource sharing platform for students learning to code`,
    image:cheatsheets,
    link:'https://bcw-cheatsheets.herokuapp.com/',
    stack:[
      rails,
      material,
      sass,
      haml,
      postgres,
      jQuery,
      git,
    ]
  }),
  new Project({
    title:`FlexBox Playground`,
    description:`The easiest way to try out css flexbox`,
    image:flexbox,
    link:'https://mccallofthewild.github.io/flexbox/',
    weight:2,
    stack:[
      ...toolkit.vue,
    ]
  }),
  new Project({
    title:`Ethos`,
    description:`Intuitive state management`,
    image:ethos,
    link:'https://github.com/mccallofthewild/ethos',
    weight:1,
    stack:[
      mocha,
      chai,
      react,
      git,
      github,
      webpack,
      flow,
      ...toolkit.advancedJS,
    ]
  }),
  new Project({
    title:'The Last Drummer',
    description:'An immersive VR game combining music and an emoji invasion',
    image:lastdrummer,
    weight:3,
    stack:[
      cSharp,
      unity,
      unityCollab,
    ]
  }),
  new Project({
    title:'Juicy Tag',
    description:'All your social media. One Link.',
    image:juicytag,
    link:'http://www.juicytag.com/',
    weight:2,
    stack:[
      rails,
      js,
      sass,
      heroku,
      postgres,
      git,
    ]
  }),
  new Project({
    title:'Drone Tracker',
    description:'Data visualization of drone strikes in the Middle East using DroneStream API',
    image:dronetracker,
    link:'http://mwolfhoffman.github.io/drone-tracker/#/home',
    weight:2,
    stack:[
      angular,
      gulp,
      browserify,
      sass,
      ...toolkit.advancedJS,
      git,
    ]
  }),
  new Project({
    title:'Magenta.fm',
    description:'A localStorage-based music app with ground-up authentication. Utilizes iTunes API',
    image:magentafm,
    link:'https://magenta-fm.herokuapp.com/',
    weight:3,
    stack:[
      jQuery,
      git,
    ]
  }),
  new Project({
    title:'Inspire',
    description:'A welcoming web app, ported to React Native. Utilizes OpenWeatherMap API.',
    image:inspire,
    weight:4,
    link:'https://mccallofthewild.github.io/inspire/',
    stack:[
      jQuery,
      reactNative,
      ...toolkit.advancedJS,
      git,
    ]
  }),
  new Project({
    title:`CJ's Mobile DJ`,
    description:`Design, Blog, SEO and Copywriting for local DJ's website, sparking a 300% increase in leads`,
    image:cjmobiledj,
    link:'http://www.cjyourdj.com/',
    weight:4,
    stack:[
      rails,
      postgres,
      sass,
      angular,
      heroku,
      design,
      seo,
      git,
    ]
  }),
  new Project({
    title:`Chuckar Notes`,
    description:`A note sharing platform, made exclusively for TVCC students.`,
    image:chuckarnotes,
    link:'http://tvccnoteapp.herokuapp.com/',
    weight:3,
    stack:[
      rails,
      jQuery,
      heroku,
      postgres,
      imageMagick,
      git,
    ]
  }),
  new Project({
    title:`Instagram Shadowban Test`,
    description:`A bot that tests if Instagram is hiding your content`,
    image:shadowban,
    link:`https://instagramshadowbantest.herokuapp.com/`,
    weight:2,
    stack:[
      restAPI,
      express,
      ...toolkit.vue,
      vuex,
      git,
    ]
  }),
  new Project({
    title:`The Cookie Cutter`,
    description:`A URL generator for DJ by Design's custom website builder`,
    image:cookiecutter,
    link:`https://thecookiecutter.herokuapp.com/`,
    weight:3,
    stack:[
      ...toolkit.vue,
      express,
    ]
  }),
  new Project({
    title:`Template Customizer - DJ by Design`,
    description:`A seemingly-static website that autofills with copy, based on URL query parameters.`,
    image:moderndj,
    link:`http://bit.ly/2qihqtE`,
    weight:2,
    stack:[
      ...toolkit.vue
    ]
  })
]

export default projects


// WEBPACK FOOTER //
// ./src/components/projects.js